// Стабильный цвет на каждого сантехника (по id) — одна и та же точка на карте, след и
// аватар-инициалы всегда одного цвета, независимо от того, где отображаются
const TECHNICIAN_COLORS = [
  '#e6194b', '#3cb44b', '#4363d8', '#f58231', '#911eb4',
  '#0b8f8f', '#c2185b', '#7a8c00', '#c76a00', '#008080',
  '#6a4fb3', '#9a6324', '#a52a2a', '#556b00', '#3b4ba0',
];

export function colorForTechnician(technicianId: string): string {
  let hash = 0;
  for (let i = 0; i < technicianId.length; i++) {
    hash = (hash * 31 + technicianId.charCodeAt(i)) >>> 0;
  }
  return TECHNICIAN_COLORS[hash % TECHNICIAN_COLORS.length];
}

export function initials(fullName: string): string {
  const parts = fullName.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const second = parts[1]?.[0] ?? '';
  return (first + second).toUpperCase();
}
